interface IconProps {
  color?: string
}

export function IdentityCard({ color }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      width="24px"
      height="18px"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3.78664C0 1.87925 1.55599 0.333008 3.47541 0.333008H20.5246C22.444 0.333008 24 1.87925 24 3.78664V14.2127C24 16.1201 22.444 17.6663 20.5246 17.6663H3.47541C1.55599 17.6663 0 16.1201 0 14.2127V3.78664ZM3.47541 2.02724C2.49759 2.02724 1.70492 2.81495 1.70492 3.78664V14.2127C1.70492 15.1844 2.49759 15.9721 3.47541 15.9721H20.5246C21.5024 15.9721 22.2951 15.1844 22.2951 14.2127V3.78664C22.2951 2.81495 21.5024 2.02724 20.5246 2.02724H3.47541Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.56295 5.28539C7.7225 5.28539 7.04118 5.96244 7.04118 6.79762C7.04118 7.6328 7.7225 8.30985 8.56295 8.30985C9.40339 8.30985 10.0847 7.6328 10.0847 6.79762C10.0847 5.96244 9.40339 5.28539 8.56295 5.28539ZM5.33626 6.79762C5.33626 5.02674 6.7809 3.59115 8.56295 3.59115C10.345 3.59115 11.7896 5.02674 11.7896 6.79762C11.7896 8.5685 10.345 10.0041 8.56295 10.0041C6.7809 10.0041 5.33626 8.5685 5.33626 6.79762Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2788 7.81494C15.2788 7.34709 15.6604 6.96782 16.1312 6.96782H18.7542C19.225 6.96782 19.6066 7.34709 19.6066 7.81494C19.6066 8.28279 19.225 8.66206 18.7542 8.66206H16.1312C15.6604 8.66206 15.2788 8.28279 15.2788 7.81494Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2788 10.4215C15.2788 9.9536 15.6604 9.57434 16.1312 9.57434H18.7542C19.225 9.57434 19.6066 9.9536 19.6066 10.4215C19.6066 10.8893 19.225 11.2686 18.7542 11.2686H16.1312C15.6604 11.2686 15.2788 10.8893 15.2788 10.4215Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.58546 12.5606C7.15193 12.5606 5.90758 13.3118 5.40671 13.8392C5.0836 14.1795 4.54408 14.1951 4.20166 13.874C3.85924 13.5529 3.84359 13.0168 4.1667 12.6765C4.94462 11.8572 6.62076 10.8663 8.58546 10.8663C10.5502 10.8663 12.2263 11.8572 13.0042 12.6765C13.3273 13.0168 13.3117 13.5529 12.9693 13.874C12.6268 14.1951 12.0873 14.1795 11.7642 13.8392C11.2633 13.3118 10.019 12.5606 8.58546 12.5606Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
